// 基于Figma设计稿提取的颜色tokens
export const colors = {
  // 主色调
  primary: {
    50: '#F8F9F7',
    100: '#E9EBDF',
    200: '#D4D7C7',
    300: '#CBCCC4',
    400: '#8B867F',
    500: '#433E38',
    600: '#242424',
    700: '#151515',
    800: '#0E352C',
    900: '#000000',
  },
  
  // 语义化颜色
  background: {
    primary: '#151515',
    secondary: '#242424',
    tertiary: '#433E38',
    card: '#242424',
    accent: '#0E352C',
  },
  
  text: {
    primary: '#E9EBDF',
    secondary: '#CBCCC4',
    muted: '#8B867F',
    inverse: '#151515',
  },
  
  border: {
    default: '#433E38',
    light: 'rgba(233, 235, 223, 0.12)',
    dark: '#242424',
  },
  
  // 状态颜色
  success: '#0E352C',
  warning: '#8B867F',
  error: '#433E38',
  info: '#242424',
  
  // 透明度变体
  alpha: {
    light6: 'rgba(233, 235, 223, 0.06)',
    light12: 'rgba(233, 235, 223, 0.12)',
    light24: 'rgba(233, 235, 223, 0.24)',
    light60: 'rgba(233, 235, 223, 0.6)',
    dark6: 'rgba(0, 0, 0, 0.06)',
    dark12: 'rgba(0, 0, 0, 0.12)',
    dark24: 'rgba(0, 0, 0, 0.24)',
    dark60: 'rgba(0, 0, 0, 0.6)',
  }
};

export default colors;
